import { throwError as observableThrowError, Observable } from 'rxjs';

import { catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Router } from '@angular/router';

import { TokenService } from './token.service';


@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private tokenService: TokenService, private router: Router) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.tokenService.hasToken()) {
      return next
        .handle(req.clone({
          setHeaders: {
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + this.tokenService.getToken(),
          }
        }))
        .pipe(catchError((error, caught) => {
          switch (error.status) {
            case 401:
              console.warn('Session del usuario ha expirado', error);
              this.tokenService.clearToken();
              this.router.navigate(['login']);
              return caught;
            case 403:
              console.warn('Acceso denegado.', error);
              break;
          }
          return observableThrowError(error);
        }));
    }

    // if no token just catch error and display it in console
    return next
      .handle(req)
      .pipe(catchError((error) => {
        console.error(error);
        return observableThrowError(error);
      }));
  }
}
